module.exports = __webpack_public_path__ + "static/media/banner-tenant.e7ed3245.png";